/**
 * #4447 GUSSTATION: a PIN session nobody has touched for two minutes returns
 * the screen to the keypad. Touch, pointer, wheel and key events reset the
 * clock; the server's own idle backstop (15 min) and the 12 h cap stand
 * whatever this timer does.
 */
import { useEffect } from "react";
import { PIN_SESSION_CLIENT_IDLE_MS } from "@shared/station";
import { switchPerson } from "@/lib/station-client";

const ACTIVITY_EVENTS = ["pointerdown", "pointermove", "keydown", "touchstart", "wheel"] as const;

export function useIdleSwitch(active: boolean, idleMs: number = PIN_SESSION_CLIENT_IDLE_MS): void {
  useEffect(() => {
    if (!active) return;
    let timer: ReturnType<typeof setTimeout> | null = null;
    let fired = false;
    const arm = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        if (fired) return;
        fired = true;
        void switchPerson();
      }, idleMs);
    };
    for (const name of ACTIVITY_EVENTS) window.addEventListener(name, arm, { passive: true });
    arm();
    return () => {
      if (timer) clearTimeout(timer);
      for (const name of ACTIVITY_EVENTS) window.removeEventListener(name, arm);
    };
  }, [active, idleMs]);
}
